module.exports = __webpack_public_path__ + "static/img/background_company_second.1f5903e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background_company_second.png
// module id = yZYl
// module chunks = 1